import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolToString'
})
export class BooleanToString implements PipeTransform {

  transform(value: string): any {
    if(value == null){
      return value;
    }
    if(value.toLocaleString().toLowerCase() == 'true' || value.toLocaleString().toLowerCase() == 'yes' || value.toLocaleString().toLowerCase() == 'enabled'){
        return 'Enabled'
    }
    if(value.toLocaleString().toLowerCase() == 'false' || value.toLocaleString().toLowerCase() == 'no' || value.toLocaleString().toLowerCase() == 'cancelled'){
        return 'Disabled'
    }
  }

}
